import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularFireModule } from "angularfire2";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFireAuthModule } from "angularfire2/auth";
import { FormsModule, FormBuilder, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { HttpClientModule } from "@angular/common/http";
import { NoAccessComponent } from "./components/no-access/no-access.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { FireBaseConfig } from "../../environments/firebaseConfig";
import { ProductService } from "./services/product.service";
import { AdminGaurd } from "./guards/admin-gaurd";
import { AuthGuard } from "./guards/auth_gaurd";
import { AuthService } from "./services/auth.service";
import { UserService } from "./services/user.service";
import { Dbutils } from "./services/db-utils";
import { CircleIconComponent } from "./components/circle-icon/circle-icon.component";
import { SearchBarComponent } from "./components/search-bar/search-bar.component";
import { RadioGroupComponent } from "./components/radio-group/radio-group.component";
import { RadioButtonComponent } from "./components/radio-group/radio-button/radio-button.component";
import { SelectComponent } from "./components/select/select.component";
import { RadioButtonSmallComponent } from "./components/radio-group-small/radio-button-small/radio-button-small.component";
import { InputComponent } from "./components/input/input.component";
import { MaterialModuleModule } from "./material-module/material-module.module";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { ObjectToArrayPipe } from "./services/object-to-array.pipe";
import { TextareaComponent } from "./components/textarea/textarea.component";
import { SlideToggleComponent } from "./components/slide-toggle/slide-toggle.component";
import { SmallCircleIconComponent } from "./components/small-circle-icon/small-circle-icon.component";
import { WindowsService } from "./services/window-service";
import { OrderTypeGuard } from "./guards/order-type_guard";
import { StepperComponent } from "./components/stepper/stepper.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { RadioGroupPaymentsComponent } from "./components/radio-group-payments/radio-group-payments.component";
import { RadioGroupSmallComponent } from "./components/radio-group-small/radio-group-small.component";
import { BrowserModule } from "@angular/platform-browser";
import { MessageModalComponent } from './components/message-modal/message-modal.component';
@NgModule({
  imports: [
    CommonModule,
    AngularFireModule.initializeApp(FireBaseConfig),
    ScrollToModule.forRoot(),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleModule,
    GooglePlaceModule,
    NgxPaginationModule,
  ],
  declarations: [
    NoAccessComponent,
    SpinnerComponent,
    PageNotFoundComponent,
    CircleIconComponent,
    SmallCircleIconComponent,
    SearchBarComponent,
    RadioGroupComponent,
    RadioButtonComponent,
    SelectComponent,
    RadioGroupSmallComponent,
    RadioGroupPaymentsComponent,
    RadioButtonSmallComponent,
    InputComponent,
    ObjectToArrayPipe,
    InputComponent,
    TextareaComponent,
    SlideToggleComponent,
    StepperComponent,
    CheckboxComponent,
    MessageModalComponent,
  ],
  exports: [
    FormsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule,
    ScrollToModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    RouterModule,
    GooglePlaceModule,
    NgxPaginationModule,
    NoAccessComponent,
    PageNotFoundComponent,
    CircleIconComponent,
    SmallCircleIconComponent,
    SelectComponent,
    SearchBarComponent,
    RadioGroupComponent,
    RadioButtonComponent,
    RadioGroupSmallComponent,
    RadioGroupPaymentsComponent,
    RadioButtonSmallComponent,
    MaterialModuleModule,
    InputComponent,
    SpinnerComponent,
    ObjectToArrayPipe,
    InputComponent,
    TextareaComponent,
    SlideToggleComponent,
    StepperComponent,
    CheckboxComponent,
    MessageModalComponent,
  ],
  providers: [
    AuthService,
    AuthGuard,
    AdminGaurd,
    OrderTypeGuard,
    ProductService,
    Dbutils,
    UserService,
    WindowsService,
    
  ],
  entryComponents: [MessageModalComponent],
})
export class SharedModule { }
